export class SetChatSession {
	static readonly type = '[ChatBot] Set the ChatBot Session';
	constructor(public sessionId: string, public orderId: string | number) {}
}

export class ClearChatSession {
	static readonly type = '[Chatbot] Clear the ChatBot Session';
}
